import React from 'react';
import SearchInput from "@core/inputs/SearchInput";
import {Tabs} from "@mui/material";
import {isArrayEmpty} from "@utils/helpers";
import _ from "lodash";
import {useTranslation} from "react-i18next";
import Review from "@components/Review";
const Header = ({onSearch, businessData, table, menu, onSelect, scroll, businessSocials}) => {
  const { t } = useTranslation();

  const search = _.debounce((e) => {
    onSearch(e || '');
  }, 400);

  return (
    <nav
      className='transition duration-300 z-20 w-full rounded-b-4xl drop-shadow-lg shadow-md'
      style={{
        position: 'sticky',
        top: 0,
        backgroundColor: 'white'
      }}
    >
      <div
        className='transition duration-300 z-20 w-full rounded-b-4xl drop-shadow-lg h-30'
        style={{
          position: 'sticky',
          top: 0,
          backgroundImage: `url(${businessData?.aggregatorPictureURL})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          zIndex: 1,
        }}>
        <div
          className="absolute bg-gradient-to-b from-transparent via-transparent to-gray-600 h-30 w-full rounded-b-4xl cursor-default">
          <div
            className="absolute bottom-3 px-5 text-white text-opacity-90 font-semibold text-3xl whitespace-nowrap">{businessData?.pageName}
          </div>
          <div
            className="absolute bottom-1 right-5 my-3 text-sm text-white px-2.5 py-0.5 whitespace-nowrap bg-gray-100 rounded-2xl bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-10 border border-gray-100"
          >
            {table?.name}
          </div>
        </div>
      </div>
      <>
        {businessData?.businessSocials?.length ? <Review businessSocials={businessData?.businessSocials}/> : null}
        <div className='w-full mt-3 px-4'>
          <SearchInput placeholder={t('search')} onKeyUp={search}/>
        </div>
        <div className="flex px-3 items-center align-middle">
          <Tabs
            variant="scrollable"
            aria-label="scrollable auto tabs example">
            {menu?.map((category) => {
              if (isArrayEmpty(category?.magProducts)) {
                return null;
              }

              return (
                <div
                  key={category.id}
                  id={`tab-${category.id}`}
                  onClick={() => {
                    onSelect(category);
                    scroll(category);
                  }}
                  className='my-3 ml-2 text-sm border rounded-3xl px-2.5 py-0.5 cursor-pointer whitespace-nowrap font-light text-gray-600'
                >
                  {category.name}
                </div>
              );
            })}
          </Tabs>
        </div>
      </>
    </nav>
  );
};

export default Header;
